import { render, staticRenderFns } from "./FirstProfile.vue?vue&type=template&id=8cb10fc8&scoped=true&"
import script from "./FirstProfile.vue?vue&type=script&lang=js&"
export * from "./FirstProfile.vue?vue&type=script&lang=js&"
import style0 from "./FirstProfile.vue?vue&type=style&index=0&id=8cb10fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb10fc8",
  null
  
)

export default component.exports